import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChess, faTriangleExclamation, faHandPointRight } from '@fortawesome/free-solid-svg-icons'
import Countdown from './Countdown';
import { useTranslation } from 'react-i18next';

export default function SimpleAlert(props) {
    const { t } = useTranslation();
    const alertContent = props.alertContent
    const textColor = alertContent.textColor ? alertContent.textColor : "text-white"

    const renderOneRule = (icon, rule) => {
        return (
            <Row>
                <Col xs={1} md={1} lg={1}>
                    <FontAwesomeIcon icon={icon} style={{ paddingRight: 8 }} />
                </Col>
                <Col xs={11} md={11} lg={11}>
                    <p>{rule}</p>
                </Col>
            </Row>
        )
    }
    return (
        <Modal
            contentClassName={`bg-dark ${textColor}`}
            show={props.show}
            onHide={props.onHide}>
            {
                alertContent.title &&
                <Modal.Header >
                    <Modal.Title style={{letterSpacing: 2, fontWeight: 200}}><FontAwesomeIcon icon={faChess} style={{ paddingRight: 8 }} />  {alertContent.title}</Modal.Title>
                </Modal.Header>
            }

            <Modal.Body>
                <Container>
                    <Row>
                        {alertContent.icon &&
                        <Col xs={1} md={1} lg={1}>
                            <FontAwesomeIcon icon={alertContent.icon} style={{ paddingRight: 8 }} />
                        </Col>
                        }

                        <Col xs={11} md={11} lg={11}>
                            <p>{alertContent.text}</p>
                        </Col>
                    </Row>

                </Container>
            </Modal.Body>
            <Modal.Footer style={{ flexWrap: 'wrap' }}>
                {!alertContent.noClose && <Button variant="secondary" onClick={props.onHide}>
                    {t('close')}
                </Button>}
                { alertContent.buttonAction &&
                     <Button variant={alertContent.buttonVariant || "warning"} onClick={alertContent.buttonAction}>
                     <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        {alertContent.buttonTimeOut && <Countdown time={alertContent.buttonTimeOut} />}
                         {alertContent.buttonText}
                        
                     </span>
                 </Button>
                }
                { alertContent.showButton2 && alertContent.buttonAction2 &&
                     <Button 
                         variant={alertContent.buttonVariant2 || "warning"} 
                         onClick={alertContent.buttonAction2}
                         disabled={alertContent.buttonDisabled2}
                         className="ms-3"
                     >
                     <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                         {alertContent.buttonText2}
                     </span>
                 </Button>
                }
                { alertContent.customFooter && 
                    <div style={{ width: '100%', flexShrink: 0, marginTop: 16 }}>
                        {alertContent.customFooter()}
                    </div>
                }
            </Modal.Footer>
        </Modal>
    );
}
